import React, { createContext, useContext, useReducer } from "react";
import { createBrowserHistory } from "history";
import axios from "axios";
import {
  SYSTEMS,
  AUTH_STATUS,
  REGEX_PATTERN,
  FORM_VALIDATION_MESSAGE,
} from "../constants";

const AuthContext = createContext();
const AuthDispatchContext = createContext();
const history = createBrowserHistory();

const reducer = (currentState, newState) => {
  return { ...currentState, ...newState };
};

const useAuth = () => {
  const c = useContext(AuthContext);
  if (!c) throw new Error("useAuth must be used in AuthProvider says MBC");
  return c;
};

const useAuthDispatch = () => {
  const c = useContext(AuthDispatchContext);
  if (!c)
    throw new Error("useAuthDispatch must be used in AuthProvider says MBC");
  return c;
};

const inital_state = {
  status: AUTH_STATUS.IDLE,
  user: null,
  error: null,
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, inital_state);
  return (
    <AuthContext.Provider value={state}>
      <AuthDispatchContext.Provider value={dispatch}>
        {children}
      </AuthDispatchContext.Provider>
    </AuthContext.Provider>
  );
}

const doLogin = async (dispatch, user, identifier = SYSTEMS.zi) => {
  try {
    dispatch({ status: AUTH_STATUS.PENDING });
    const res = await axios.post(
      `${process.env.REACT_APP_AUTH_API_URL}/2/login`,
      user
    );

    if(res?.data?.accounts?.length === 0) {
      throw new Error("Login failure");
    }

    if (res?.data?.success) {
      delete user.password;
      user = {
        jwt: res.data.jwt,
        accounts: res.data.accounts,
        ip_address: res.data.ip_address,
        ...res.data.record,
      };
      _doLoginSuccess(dispatch, user, identifier);
      return;
    }
    
    throw new Error("Login failure");
  } catch (e) {
    dispatch({
      status: AUTH_STATUS.DECLINED,
      error: { ...e, message: "Incorrect credentials." },
    });
  }
};

const _doLoginSuccess = (dispatch, user, identifier) => {
  console.log(identifier)
  switch (identifier) {
    case SYSTEMS.zi:
      window.location.href = `${
        process.env.REACT_APP_REDIRECT_URL_INNOVATIONS
      }?token=${encodeURIComponent(window.btoa(JSON.stringify(user)))}`;
      break;
    case SYSTEMS.zs:
      window.location.href = `${
        process.env.REACT_APP_REDIRECT_URL_STREAM
      }/videos/?token=${encodeURIComponent(window.btoa(JSON.stringify(user)))}`;
      break;
    case SYSTEMS.zl:
      window.location.href = `${
        process.env.REACT_APP_REDIRECT_URL_LAUNCH
      }/auth/sso?email=${encodeURIComponent(user.email)}&token=${user.jwt}`;
      break;
    default:
      break;
  }
};

const updateUser = (dispatch, user, isLoginFailed) => {
  dispatch({
    status: isLoginFailed ? AUTH_STATUS.IDLE : AUTH_STATUS.APPROVED,
    user: user,
    error: null,
  });
};

const doLogout = (dispatch) => {
  dispatch(inital_state);
  localStorage.removeItem("_token");
  history.push("/login");
};

const forgetPassword = async (dispatch, email) => {
  try {
    dispatch({ status: AUTH_STATUS.PENDING });
    const res = await axios.post(
      `${process.env.REACT_APP_AUTH_API_URL}/2/forget-password`,
      { email }
    );
    if (res?.data?.success) {
      dispatch({ status: AUTH_STATUS.APPROVED });
      return;
    }
    throw new Error("error");
  } catch (e) {
    dispatch({
      status: AUTH_STATUS.DECLINED,
      error: {
        message: e?.response?.data?.message || "Forget password failure.",
      },
    });
  }
};

const resetPassword = async (dispatch, data) => {
  try {
    const { password, confirmPassword } = data;
    if (password !== confirmPassword) {
      dispatch({ error: { message: "Passwords do not match." } });
      return false;
    }
    if (!REGEX_PATTERN.USER_PASS.test(password)) {
      dispatch({ error: { message: FORM_VALIDATION_MESSAGE.USER_PASS } });
      return false;
    }
    dispatch({ status: AUTH_STATUS.PENDING });
    const res = await axios.post(
      `${process.env.REACT_APP_AUTH_API_URL}/2/reset-password`,
      data
    );
    if (res?.data?.success) {
      dispatch({ status: AUTH_STATUS.APPROVED });
      return;
    }
    throw new Error("error");
  } catch (e) {
    dispatch({
      status: AUTH_STATUS.DECLINED,
      error: {
        message: e?.response?.data?.message || "Reset password failure.",
      },
    });
  }
};

export {
  AuthProvider,
  useAuth,
  useAuthDispatch,
  doLogin,
  doLogout,
  updateUser,
  forgetPassword,
  resetPassword,
};
